import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle, ArrowUUpLeft, ClockCountdown, ListChecks } from "@phosphor-icons/react";

const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString("ro-RO", { day: "2-digit", month: "short" }) : "—");
const isLate = (iso) => iso && new Date(iso) < new Date();

export default function MyTasksWidget() {
  const [tasks, setTasks] = useState(null);
  const load = () => api.get("/wf/my-tasks").then((r) => setTasks(r.data)).catch(() => setTasks([]));
  useEffect(() => { load(); }, []);

  const complete = async (t) => {
    try { await api.post(`/projects/${t.project_id}/workflow/nodes/${t.node_id}/complete`, {}); toast.success("Finalizat"); load(); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  };
  const back = async (t) => {
    try { await api.post(`/projects/${t.project_id}/workflow/nodes/${t.node_id}/transfer`, { kind: "return", action: "clarify", message: "Întors pentru clarificare" }); toast.success("Întors la expeditor"); load(); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  };

  if (tasks === null) return null;

  return (
    <div className="rounded-xl border border-border bg-card p-6" data-testid="my-tasks-widget">
      <div className="mb-4 flex items-center gap-2">
        <ListChecks size={20} weight="bold" className="text-primary" />
        <h3 className="font-head text-lg font-bold">Activitățile mele</h3>
        {tasks.length > 0 && <span className="rounded-full bg-primary/15 px-2 py-0.5 text-xs font-bold text-primary">{tasks.length}</span>}
      </div>
      <div className="space-y-2">
        {tasks.map((t) => (
          <div key={t.node_id} className="flex flex-wrap items-center gap-3 rounded-lg border border-border/70 px-3 py-2.5" data-testid={`my-task-${t.code || t.node_id}`}>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2">
                {t.code && <span className="rounded bg-white/5 px-1.5 py-0.5 font-mono text-[11px]">{t.code}</span>}
                <span className="truncate text-sm font-medium">{t.node_name}</span>
              </div>
              <Link to={`/projects/${t.project_id}`} className="text-xs text-muted-foreground hover:text-foreground">
                {t.project_code} · {t.project_name}
              </Link>
            </div>
            <span className={`flex items-center gap-1 rounded px-2 py-0.5 text-[11px] font-bold ${isLate(t.due_at) ? "bg-red-500/15 text-red-400" : "bg-emerald-500/15 text-emerald-400"}`}>
              <ClockCountdown size={13} /> {isLate(t.due_at) ? "întârziat" : fmt(t.due_at)}
            </span>
            <div className="flex gap-1">
              <Button variant="ghost" size="sm" className="text-orange-400" onClick={() => back(t)} data-testid={`my-task-return-${t.code || t.node_id}`}><ArrowUUpLeft size={16} /></Button>
              <Button variant="ghost" size="sm" className="text-emerald-400" onClick={() => complete(t)} data-testid={`my-task-complete-${t.code || t.node_id}`}><CheckCircle size={17} /></Button>
            </div>
          </div>
        ))}
        {tasks.length === 0 && <p className="text-sm text-muted-foreground">Nicio activitate transmisă către tine. 🎉</p>}
      </div>
    </div>
  );
}
